<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="description" class="col-12 mb-2 md:mb-0">Feedback / Comment About The Employee</label>
                    <div class="col-12">
                        <Textarea id="comment" name="comment" class="w-full" v-model="form.comment"></Textarea>
                    </div>
                </div>
                <div class="field grid">
                    <h5 class="col-12 mb-2 md:mb-0">Response From The Employee</h5>
                </div>
                <div class="field grid">
                    <Checkbox id="jamsostek" class="mx-2 mx-2" v-model="form.is_agree_with_given_score" :binary="true" name="is_jamsostek" />
                    <label for="jamsostek">Agree With The Results</label>
                </div>
                <div class="field grid">
                    <Checkbox id="jamsostek" class="mx-2 mx-2" v-model="form.is_agree_with_things_to_fix" :binary="true" name="is_jamsostek" />
                    <label for="jamsostek">Agree With Some Points That Must Be Adjusted</label>
                </div>
                <div class="field grid">
                    <Checkbox id="jamsostek" class="mx-2 mx-2" v-model="form.is_not_agree" :binary="true" name="is_jamsostek" />
                    <label for="jamsostek">Disagree</label>
                </div>
                <div class="field grid" v-if="form.is_not_agree">
                    <label for="reason" class="col-12 mb-2 md:col-2 md:mb-0">Reason</label>
                    <div class="col-12 md:col-5">
                        <Textarea>Asasdjnkasd</Textarea>
                    </div>
                </div>
                <div class="field grid">
                    <h5 class="col-12 mb-2 md:col-2 md:mb-0">Conclusion:</h5>
                </div>
                <div class="field grid">
                    <p class="mb-2 md:col-2 md:mb-0">The Employee</p>
                    <Dropdown
                        :class="{'p-invalid' : submitted && !form.is_capable }"
                        v-model="form.is_capable"
                        :options="capableValues"
                        option-label="code"
                        option-value="value"
                        required="true" />
                    <p class="my-2 mx-2">To Continue the contract</p>
                </div>
                <div class="field grid" v-if="form.is_capable">
                    <p class="text-bold mb-2 md:mb-0 my-2 mx-2">The Employee {{ form.contract_duration  }} To Continue the contract with duration of </p>
                    <Dropdown
                        :class="{'p-invalid' : submitted && !form.contract_duration }"
                        v-model="form.contract_duration"
                        :options="contractDurations"
                        required="true" />
                </div>
                <div class="field grid" v-if="form.is_capable">
                    <p class="text-bold mb-2 md:col-2 md:mb-0">With Salary </p>
                    <div class="col-8 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.salary"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AutoComplete from 'primevue/autocomplete';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';
import axios from 'axios';
export default{
    components:{
        AutoComplete,
        Calendar,
        Checkbox,
        Dropdown,
        InputText,
        InputNumber,
        Textarea
    },
    props:['submitted'],
    data(){
        return{
            form: this.$page.props.assessement ?
                {
                    comment: this.$page.props.assessement.comment,
                    is_agree_with_given_score: this.$page.props.assessement.is_agree_with_given_score,
                    is_agree_with_things_to_fix: this.$page.props.assessement.is_agree_with_things_to_fix,
                    is_not_agree: this.$page.props.assessement.is_not_agree,
                    is_capable: this.$page.props.assessement.is_capable,
                    contract_duration: this.$page.props.assessement.contract_duration,
                    salary: this.$page.props.assessement.salary,
                } :
                {
                    comment:'',
                    is_agree_with_given_score: false,
                    is_agree_with_things_to_fix: false,
                    is_not_agree: false,
                    is_capable: '',
                    contract_duration: '',
                    salary: 0
                },
            placements: [],
            divisions: [],
            positions: [],
            positionClasses: [],
            employees: [],
            submitted: false,
            autoFilteredValue: [],
            capableValues : [{code: "Capable", value: true},{code: "Not Capable", value: false}],
            contractDurations: ['one week', 'two weeks', 'three weeks', 'one month', 'two months','three months','four months','five month','six months','seven months','eight months','nine months','ten months','eleven months','one year','two year','three year','four year','five year'],
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        searchCandidate(event) {
				setTimeout(() => {
					if (!event.query.trim().length) {
                        axios.get(`${this.$page.props.appUrl}api/applicants`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
					else {
                        let filterValue = event.query.toLowerCase();
                        axios.get(`${this.$page.props.appUrl}api/applicants?search=${filterValue}`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
				}, 250);
			},
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data)=>{
                this.placements = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
            .then((data)=>{
                this.divisions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/positions`)
            .then((data)=>{
                this.positions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/position-classes`)
            .then((data)=>{
                this.positionClasses= data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/employees`)
            .then((data)=>{
                this.employees = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        }
    }
    }
</script>
